<template>
  <div id="examPaperCommandWrap" class="flex-1 overflow-y-auto h-full relative">
    <div class="px-10px py-10px title-wrap">
      <div class="text-center">
        <div class="text-30px my-10px">{{ originData.content && originData.content.examName }}</div>
        <div>
          <span class="mr-20px"
            >试卷总分：{{ originData.content && originData.content.paperScore }}分</span
          >
          <span>考试时间：{{ originData.content && originData.content.examDuration }}分钟</span>
        </div>
      </div>
      <!-- <div>
        <p class="font-600 mb-2px">考试须知</p>
        <div class="leading-16px px-4px">
          1.考试前请认真听监考员阅读考试须知，熟知考试规则和细节。
          2.保证考试环境的安静，提前确定好网络是否通畅，考试时摄像头开启并方位正确，考试中通不要离开座位。
          3.考试前请将手机调至静音，打开勿扰模式防止出现意外，影响考试。
          4.考试严格按照考试时间和流程参加考试，不得提前或延后，未在现定时间参加考试者，视为自愿放弃考试资格。
          5.参加考试，除应自行准备好考试必需品外，其他物品(包括手机、手、其他电子设备、书本及学习资料等)
          禁止带入考试答题区(主辅机位监控区)。
          6.考生需严格遵守考场纪律，服从工作人员指挥，违反规定者，取消考试资格。
          7.考区内严禁使用通讯工具， 违反规定者按作弊处理。 8.考试期间考生双手在主、辅机位监控下答
          题，不得超出画面，不得故意遮挡双机位视角，不得左顾右盼，视线脱离答题区，否则视为作弊
        </div>
      </div> -->
    </div>
    <div class="px-15px py-15px">
      <div v-for="(item, index) in sourceData" :key="index">
        <div class="flex mb-16px items-center">
          <div class="exam-menu text-18px font-600  mr-30px">
            {{ chartperIndex[index] + '.' + typeTopicList[item.questionType] }}题
          </div>
          <p class="deserve-score">{{ item.questionType | showText(renderData) }}</p>
        </div>

        <div v-if="[0, 1].includes(item.questionType)">
          <div v-for="(content, order) in item.topicContents" :key="order">
            <div class="topic flex">
              <span class="mr-30px">
                {{ getTitle(content) + '（ ' + (content.examineeAnswerContent || '') + ' ）' }}
              </span>
              <span v-html="getIcon(content.examineeAnswerContent === content.correct)"></span>
            </div>
            <div class="content my-10px px-20px flex justify-between flex-wrap">
              <div
                class="flex items-center mb-16px min-w-1/5"
                v-for="(option, number) in JSON.parse(content.topicContent)"
                :key="number"
              >
                <p
                  class="exam-pointer w-30px h-30px mr-4px text-center leading-30px"
                  :class="
                    content.correct.includes(words[number])
                      ? 'exam-pointer_corret'
                      : 'exam-pointer_error'
                  "
                >
                  {{ words[number] }}
                </p>
                <p v-html="option.content"></p>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="item.questionType === 2">
          <div v-for="(content, order) in item.topicContents" :key="order">
            <div class="topic flex mb-15px">
              <span class="mr-30px">
                <span class="mr-3px">{{ getTitle(content) }}（</span>
                <span
                  v-html="
                    getIcon(
                      content.examineeAnswerContent ? content.examineeAnswerContent === 'A' : ''
                    )
                  "
                ></span>
                <span class="ml-3px">）</span>
              </span>
              <span v-html="getIcon(content.examineeAnswerContent === content.correct)"></span>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-for="(content, order) in item.topicContents" :key="order">
            <div class="topic">
              <span class="mr-30px">
                {{ getTitle(content) }}
              </span>
              <el-input-number
                style="width: 120px"
                size="small"
                v-model="content.examineeScore"
                :precision="0"
                :min="0"
                :max="content.score"
                :controls="false"
                @change="$emit('updateScore')"
                :disabled="!isAbled"
              />
            </div>
            <div class="content my-10px px-20px ">
              <div class="answer" v-html="content.examineeAnswerContent"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center w-full bottom-0px left-0px mb-15px" v-if="isAbled">
      <el-button size="mini" @click="subData" class="w-80px" v-if="originData.content"
        >保存</el-button
      >
      <el-button size="mini" @click="cancel" class="w-80px bt_bg">取消</el-button>
    </div>
  </div>
</template>
<script>
import { wordsList } from '@/components/safety/enumField/enumTagType'

export default {
  name: 'exam-paper-com',
  components: {},
  props: {
    renderData: {
      type: Array,
      default: () => {
        return []
      },
    },
    originData: {
      type: Object,
      default: () => {},
    },
    isAbled: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    showText: (val, type) => {
      const data = type.find((item) => {
        return val === item.questionType
      })
      const res = data?.score || 0
      return `${res}分`
    },
  },
  computed: {
    sourceData: {
      get() {
        return this.renderData
      },
      set(val) {
        this.$emit('update:renderData', val)
      },
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
  },
  data() {
    return {
      equipDataList: [],
      chartperIndex: ['一', '二', '三', '四', '五'],
      words: wordsList,
      typeTopicList: ['单选', '多选', '判断', '填空', '简答'],
    }
  },
  methods: {
    subData() {
      this.$emit('goSave')
    },
    getTitle(val) {
      return `${val.ordination}.(${val.score}分)${val.topic}`
    },
    cancel() {
      this.$router.push(
        `${this.basePath}/educational-training-management-sm/exam-manage/paper-inspection`
      )
    },
    getIcon(isTrue) {
      if (isTrue === '' || isTrue === null) return ''
      if (isTrue) {
        return '<i class="el-icon-success text-18px" style="color:#00ff0d"></i>'
      }
      return '<i class="el-icon-error text-18px text-red-500"></i>'
    },
  },
  mounted() {
    // console.log(this.originData)
  },
}
</script>

<style lang="scss">
.bt_bg {
  background-color: #a3adb3;
}
#examPaperCommandWrap {
  .topic {
    .el-input__inner {
      color: red !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.title-wrap {
  border-bottom: 1px solid #d9d9d9;
  font-size: 13px;
}
.deserve-score {
  width: 66px;
  height: 25px;
  line-height: 25px;
  color: red;
  background-color: #d9d9d9;
  text-align: center;
}
.content {
  .exam-pointer {
    min-width: 30px;
  }
  .exam-pointer_corret {
    border-radius: 50%;
    background-color: #0099ff;
    color: #fff;
    border: 1px solid #d9d9d9;
  }
  .exam-pointer_error {
    border-radius: 50%;
    border: 1px solid #d9d9d9;
  }
  .answer {
    background-color: #d9d9d9;
    padding: 2px;
    font-size: #000;
    font-size: 12px;
    min-height: 50px;
  }
}
</style>
